import React, { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import {
   getStorage,
   ref,
   uploadBytesResumable,
   getDownloadURL,
} from "firebase/storage"
import app from "../../firebase"
// Components
import Topbar from "../../components/Topbar/Topbar"
import Sidebar from "../../components/Sidebar/Sidebar"
import { Publish } from "@material-ui/icons"
// Data
import { createImage } from "../../redux/apiCalls"
// Styles
import {
   Container,
   Wrapper,
   Main,
   Title,
   StyledForm,
   FormItem,
   StyledLabel,
   StyledInput,
   StyledButton,
   ButtonContainer,
   ButtonWrapper,
   Message,
   CreateImage,
   UploadIcon,
   TitleWrapper,
} from "./NewImage.styles"

const NewImage = () => {
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const [errorMessage, setErrorMessage] = useState("")
   const [sectionInput, setSectionInput] = useState("")
   const [imageInput, setImageInput] = useState([])

   const handleSection = (e) => {
      setSectionInput(e.target.value)
   }

   const handleImage = (e) => {
      e.preventDefault()

      const storage = getStorage(app)
      let storageRef
      let files = Array.from(e.target.files)
      let imagesList = imageInput

      for (let i = 0; i < files.length; i++) {
         const numberPrefix = i < 10 ? "0" : ""
         const fileName =
            sectionInput + "_" + numberPrefix + i + "_" + files[i].name

         storageRef = ref(storage, `pictures/${fileName}`)
         const uploadTask = uploadBytesResumable(storageRef, files[i])
         uploadTask.on(
            "state_changed",
            (snapshot) => {
               const progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100
               console.log("Upload is " + progress + "% done")
               switch (snapshot.state) {
                  case "paused":
                     console.log("Upload is paused")
                     break
                  case "running":
                     console.log("Upload is running")
                     break
                  default:
               }
            },
            (error) => {
               console.log(error)
            },
            () => {
               getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                  console.log("File available at", downloadURL)

                  imagesList.push({
                     section: sectionInput,
                     name: fileName,
                     imageLink: downloadURL,
                  })
               })
            }
         )
      }
      console.log(imagesList)
      setImageInput(imagesList)
   }

   const handleSubmit = async (e) => {
      e.preventDefault()
      for (let i = 0; i < imageInput.length; i++) {
         const res = await createImage(imageInput[i], dispatch)
         if (res !== "success") {
            setErrorMessage(JSON.stringify(res))
            break
         }
      }
      navigate("/images")
   }

   console.log(imageInput)

   return (
      <>
         <Topbar />
         <Container>
            <Wrapper>
               <Sidebar />
            </Wrapper>
            <Main>
               <TitleWrapper>
                  <Title>New Images</Title>
               </TitleWrapper>
               <StyledForm>
                  <FormItem>
                     <StyledLabel>Section</StyledLabel>
                     <StyledInput
                        type="number"
                        name="section"
                        onChange={handleSection}
                     />
                  </FormItem>
                  <FormItem>
                     <StyledLabel>Images</StyledLabel>
                     {imageInput.map((img) => (
                        <CreateImage key={img.name} src={img.imageLink} />
                     ))}
                     <StyledLabel htmlFor={"image_files"}>
                        <UploadIcon>
                           <Publish />
                        </UploadIcon>
                     </StyledLabel>
                     <StyledInput
                        type="file"
                        id="image_files"
                        name="image_files"
                        style={{ display: "none" }}
                        multiple={true}
                        onChange={(e) => handleImage(e)}
                     />
                  </FormItem>
               </StyledForm>
               <ButtonContainer>
                  <ButtonWrapper>
                     <StyledButton onClick={handleSubmit}>Create</StyledButton>
                     <Message>{errorMessage}</Message>
                  </ButtonWrapper>
               </ButtonContainer>
            </Main>
         </Container>
      </>
   )
}

export default NewImage
